// /users/levelHandle
import { BasicService } from "./core/basic.service";


export class VipGradeService extends BasicService {

  static operate(tag, data) { // 增删查改
    return this.http.post('/users/levelHandle',{ tag, ...data});
  }

  static getList() {
    return this.http.post('/users/levelList');
  }

  // static async save(data) {
  //   const reqData = JSON.parse(JSON.stringify(data))
  //   await this.extractImg(reqData, 'head_pic');
  //   return this.http.post('/users/userSave', reqData);
  // }
}